import clsx from 'clsx';
import React from 'react';

import { useFieldContext, FieldErrors } from '..';
import { Checkbox } from '../../Elements';

type ToggleFieldProps = {
	className?: string;
	labelClassName?: string;
	label: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const ToggleField = ({
	label,
	labelClassName,
	disabled,
	...inputProps
}: ToggleFieldProps) => {
	const field = useFieldContext<string>();

	// hide the error messages until the field has been touched
	const hideErrors = !field.state.meta.isTouched;
	const hasErrors = field.state.meta.errors.length > 0 && !hideErrors;

	return (
		<>
			<div className='grid grid-flow-row-dense grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 py-4'>
				<div className='flex justify-between'>
					{label && (
						<label
							htmlFor={field.name}
							className={clsx(
								'block text-body-md text-primaryTextDark',
								labelClassName,
								disabled ? 'text-disabledInputText' : 'cursor-pointer'
							)}
						>
							{label}
						</label>
					)}
					<label htmlFor={field.name}>
						<div
							className={`relative inline-flex items-center ${disabled ? '' : 'cursor-pointer'}`}
						>
							<Checkbox
								{...inputProps}
								name={field.name}
								id={field.name}
								className='sr-only peer'
								value='true'
								handleChange={field.handleChange}
								aria-invalid={hasErrors ? 'true' : 'false'}
								aria-errormessage={hasErrors ? `${field.name}-error` : ''}
								checked={field.state.value === 'true'}
								disabled={disabled}
							/>
							<div className='group peer ring-0 bg-secondaryTextDark rounded-full outline-none duration-300 after:duration-300 w-12 h-6 shadow-md peer-checked:bg-primaryBrand peer-focus:outline-none after:rounded-full after:absolute after:bg-gray-50 after:outline-none after:h-4 after:w-4 after:top-1 after:left-1 after:-rotate-180 after:flex after:justify-center after:items-center peer-checked:after:translate-x-6 peer-hover:after:scale-95 peer-checked:after:rotate-0'></div>
						</div>
					</label>
				</div>
			</div>
			<FieldErrors name={field.name} meta={field.state.meta} hideErrors={hideErrors} />
		</>
	);
};
